module.exports = __webpack_public_path__ + "img/b58026f.png";